export default function getInitState() {
    return {
        formIsOpen: false,
        gridIsOpen: true,
        dataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        actions: [
            {
                btn_text: '<i class="fas fa-plus"></i> Új Egészségügyi törzslap',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'newRow'
            }
        ],
        formActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToGrid'
            },
            {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary my-custom-class mx-1",
                event_payload: 'resetForm'
            },
            {
                btn_text: '<i class="fas fa-print"></i> Mentés és nyomtatás',
                event_name: "customClick",
                class: "btn btn-success my-custom-class mx-1",
                event_payload: 'saveAndPrint'
            }
        ],
        rowActions: [
            {
                btn_text: '<i class="fas fa-print"></i>',
                title: 'Nyomtatás',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'printRow'
            },
            {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'modifyRow'
            },
            {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteRow'
            },
            {
                btn_text: '<i class="fas fa-undo"></i>',
                title: 'Visszaállítás',
                event_name: "customClick",
                class: "btn btn-outline-warning",
                seeCaseOfDeleted: true,
                event_payload: 'unDeleteRow'
            }
        ],
        headerFields: [
            {
                name: "id",
                label: "ID",
                visibility: false
            },
            {
                name: "treatmentId",
                label: "treatmentId",
                visibility: false
            },
            {
                name: "treatment",
                label: "treatment",
                visibility: false
            },
            {
                name: "treatment.startDate",
                label: "Kezelés időpontja",
                slot_name: "startDate_format",
                visibility: true
            },
            {
                name: "patientId",
                label: "patientId",
                visibility: false
            },
            {
                name: "patient",
                label: "Páciens",
                visibility: false
            },
            {
                name: "createdBy",
                label: "Létrehozó",
                visibility: true
            },
            {
                name: "createdOn",
                label: "Létrehozás időpontja",
                slot_name: "created_on_format",
                visibility: true
            },
            {
                name: "modifiedBy",
                label: "modifiedBy",
                visibility: false
            },
            {
                name: "modifiedOn",
                label: "modifiedOn",
                visibility: false
            },
            {
                name: "deleted",
                label: "deleted",
                visibility: false
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ]
    }
}
